import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFive = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.779 16.9728C11.0398 16.9728 10.4158 16.848 9.90704 16.5984C9.40784 16.3392 8.99024 16.0416 8.65424 15.7056L9.41744 14.64C9.69584 14.8992 10.0078 15.1296 10.3534 15.3312C10.699 15.5232 11.1022 15.6192 11.563 15.6192C12.0718 15.6192 12.4942 15.4656 12.8302 15.1584C13.1662 14.8512 13.3342 14.4192 13.3342 13.8624C13.3342 13.3152 13.1806 12.8928 12.8734 12.5952C12.5662 12.2976 12.1582 12.1488 11.6494 12.1488C11.3518 12.1488 11.1022 12.192 10.9006 12.2784C10.699 12.3552 10.459 12.4848 10.1806 12.6672L9.38864 12.1632L9.66224 7.6416H14.5582V9.0384H11.1022L10.915 11.256C11.107 11.16 11.2942 11.088 11.4766 11.04C11.6686 10.9824 11.8846 10.9536 12.1246 10.9536C12.6526 10.9536 13.1326 11.0544 13.5646 11.256C13.9966 11.4576 14.3422 11.7696 14.6014 12.192C14.8702 12.6144 15.0046 13.1568 15.0046 13.8192C15.0046 14.4816 14.851 15.048 14.5438 15.5184C14.2462 15.9888 13.8526 16.3488 13.363 16.5984C12.8734 16.848 12.3454 16.9728 11.779 16.9728Z",
		fill: "currentcolor"
	})]
});
export default SvgFive;
